import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },

    title: {
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: 700,
      color: 'var(--x-black)',
      borderLeft: '1px solid #E3E3E3',
      paddingInlineStart: 16,
    },

    image: {
      width: 28,
      height: 28,
      marginInlineEnd: 16,
    },

    share: {
      height: 'auto',
      width: 'auto',

      '&>button': {
        padding: 0,

        '&:hover': {
          background: 'none',
        },
      },
    },
  },
  {
    name: 'AppLogo',
  },
);

export default useStyles;
